import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "../../../utils";
export type TLabelProps = React.LabelHTMLAttributes<HTMLLabelElement> &
  VariantProps<typeof labelVariants>;

const labelVariants = cva(
  "inline-block text-sm leading-5 peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
  {
    variants: {
      variant: {
        default: "text-foreground",
        semiGray: "text-secondary",
      },
      weight: {
        default: "font-normal",
        medium: "font-medium",
        semiBold: "font-semibold",
        bold: "font-bold",
        light: "font-light",
      },
      size: {
        xs: "text-xs",
        sm: "text-sm",
        md: "text-md",
      },
    },
    defaultVariants: {
      variant: "default",
      weight: "default",
      size: "sm",
    },
  },
);

const Label = React.forwardRef<HTMLLabelElement, TLabelProps>(
  ({ className, variant, weight, size, ...props }, ref) => (
    <label
      ref={ref}
      className={cn(labelVariants({ variant, weight, size }), className)}
      {...props}
    />
  ),
);
Label.displayName = "Label";

export { Label };
